module.exports = __webpack_public_path__ + "img/Humanisme_Tanker_i_tida2.208eb30e.jpg";